import api from "../../api"; 

const baseURL = process.env.REACT_APP_BASE_URL + "/clli";

class ClliService {

    createClli(clli){
        return api.post(baseURL + "/save", clli);
    }

    getClliById(clliCd){
        return api.get(baseURL + '/search?idNum=' + clliCd);
    }    

    updateClli(clli){
        return api.post(baseURL, clli);
    }

    deleteClli(clliCd){
        return api.post(baseURL + '/delete?clliCd=' + clliCd);
    }

    deleteClliById(idNum){
        return api.post(baseURL + '/delete?idNum=' + idNum);
    }

    deleteBatchClli(clli){
        return api.post(baseURL + '/deleteall',  clli);
    }

    
}

export default new ClliService()